/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'redux/store/store';

import { DspState, DspInsertionOrder } from './dspApiTypes';

export const initialState: DspState = {
  isLoading: false,
  insertionOrders: null,
  error: null,
};

export const dspSlice = createSlice({
  name: 'dsp',
  initialState,
  reducers: {
    getInsertionOrdersStart(state: DspState, action: PayloadAction<string>) {
      state.isLoading = true;
      state.insertionOrders = null;
    },
    getInsertionOrdersSuccess(state: DspState, action: PayloadAction<DspInsertionOrder[]>) {
      state.isLoading = false;
      state.insertionOrders = action.payload;
      state.error = null;
    },
    getInsertionOrdersFailure(state: DspState, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    updateInsertionOrdersStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    updateInsertionOrdersSuccess: (state, action) => {
      state.isLoading = false;
      state.insertionOrders = action.payload;
    },
    updateInsertionOrdersFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    updateLineItemsStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    updateLineItemsSuccess: (state, action) => {
      state.isLoading = false;
    },
    updateLineItemsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    updateStatusStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    updateStatusSuccess: (state, action) => {
      state.isLoading = false;
      state.insertionOrders = action.payload;
    },
    updateStatusFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    refreshDspMetadataStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    refreshDspMetadataSuccess: (state, action) => {
      state.isLoading = false;
    },
    refreshDspMetadataFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const getDspState = ({ dsp }: AppState) => dsp;
export const getIsDspLoading = (state: AppState) => getDspState(state).isLoading;
export const getError = (state: AppState) => getDspState(state).error;

export const {
  getInsertionOrdersStart,
  getInsertionOrdersSuccess,
  getInsertionOrdersFailure,
  updateInsertionOrdersStart,
  updateInsertionOrdersSuccess,
  updateInsertionOrdersFailure,
  updateLineItemsStart,
  updateLineItemsSuccess,
  updateLineItemsFailure,
  updateStatusStart,
  updateStatusSuccess,
  updateStatusFailure,
  refreshDspMetadataStart,
  refreshDspMetadataSuccess,
  refreshDspMetadataFailure,
} = dspSlice.actions;
export const dsp = dspSlice.reducer;
